// Feature 322: idempotent and also run on shopify:section:load, because the theme
// editor swaps in new section HTML without firing DOMContentLoaded again (a
// re-rendered tab menu would otherwise have dead buttons).
function bindTabs(scope) {
  // Click-to-switch is wired globally (changeTabs scopes itself via
  // .closest('.tab-grand'), so this already works correctly across
  // multiple independent tab groups on one page).
  scope.querySelectorAll('.tab-button').forEach((tab) => {
    if (tab.dataset.tabsBound) return;
    tab.dataset.tabsBound = 'true';
    tab.addEventListener("click", changeTabs);
  });

  // Arrow-key roving-tabindex navigation, scoped per .tab-menu instance —
  // a page can have more than one tab group (e.g. this theme's PDP tabs
  // alongside a tabbed-carousel section), each needs its own tabFocus
  // state, not one shared module-level counter.
  scope.querySelectorAll('.tab-menu').forEach((tabList) => {
    if (tabList.dataset.tabsKeysBound) return;
    tabList.dataset.tabsKeysBound = 'true';
    const tabs = tabList.querySelectorAll('.tab-button');
    let tabFocus = 0;

    tabList.addEventListener("keydown", (e) => {
      // Move right
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        tabs[tabFocus].setAttribute("tabindex", -1);
        if (e.key === 'ArrowRight') {
          tabFocus++;
          // If we're at the end, go to the start
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
          // Move left
        } else if (e.key === 'ArrowLeft') {
          tabFocus--;
          // If we're at the start, move to the end
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }

        tabs[tabFocus].setAttribute("tabindex", 0);
        tabs[tabFocus].focus();
      }
    });
  });
}

window.addEventListener("DOMContentLoaded", () => bindTabs(document));
document.addEventListener("shopify:section:load", (e) => bindTabs(e.target));

function changeTabs(e) {
  const target = e.target;
  const tabId = target.getAttribute("aria-controls");
  const grandparent = target.closest('.tab-grand');

  // Remove all current selected tabs
  grandparent
    .querySelectorAll('[aria-selected="true"]')
    .forEach((t) => {
      t.setAttribute("aria-selected", false);
      t.setAttribute("tabindex", -1);
    });

  // Set this tab as selected
  target.setAttribute("aria-selected", true);
  target.setAttribute("tabindex", 0);

  // Hide all tab panels
  grandparent
    .querySelectorAll('.tab-content')
    .forEach((p) => p.setAttribute("hidden", true));

  // Show the selected panel
  const selectedPanel = grandparent.querySelector(`#${CSS.escape(tabId)}`);
  if (selectedPanel) {
    selectedPanel.removeAttribute("hidden");
  }
}
